import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "news-container"
  }, [_c("van-pull-refresh", {
    attrs: {
      "loading-text": _vm.$t("LoadingTxt"),
      "loosing-text": _vm.$t("LoosingTxt"),
      "pulling-text": _vm.$t("pullingTxt")
    },
    on: {
      refresh: _vm.onRefresh
    },
    model: {
      value: _vm.isLoading,
      callback: function callback($$v) {
        _vm.isLoading = $$v;
      },
      expression: "isLoading"
    }
  }, [_c("div", {
    staticClass: "swipe-con"
  }, [_c("van-swipe", {
    staticClass: "my-swipe",
    attrs: {
      autoplay: 3000,
      "indicator-color": "white"
    }
  }, _vm._l(_vm.banner, function (item, index) {
    return _c("van-swipe-item", {
      key: index,
      on: {
        click: function click($event) {
          return _vm.toLink(item.url);
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.bannerUrl,
        alt: ""
      }
    }), _c("div", {
      staticClass: "swipe-text"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]);
  }), 1)], 1), _c("div", {
    staticClass: "comments"
  }, [_vm.newsData.length > 0 ? _c("van-list", {
    attrs: {
      finished: _vm.finished,
      "finished-text": _vm.$t("NoMoreContents")
    },
    on: {
      load: _vm.onLoad
    },
    model: {
      value: _vm.loading,
      callback: function callback($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, _vm._l(_vm.newsData, function (item, index) {
    return _c("van-cell", {
      key: index,
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.likeReward.postCount);
        }
      }
    }, [_c("div", {
      staticClass: "main1 flex-col"
    }, [_c("div", {
      staticClass: "group9 flex-row justify-between"
    }, [_c("div", {
      staticClass: "mod1 flex-col justify-between"
    }, [item.title ? _c("span", {
      staticClass: "word5"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _c("span", {
      staticClass: "word66"
    }, [_vm._v(_vm._s(item.content.text))]), _c("div", {
      staticClass: "box4 flex-row"
    }, [_c("span", {
      staticClass: "word6"
    }, [_vm._v(_vm._s(item.createdAt))]), _c("img", {
      staticClass: "like",
      attrs: {
        src: require("../../../assets/images/ic_other_more_comment.png")
      }
    }), _c("span", {
      staticClass: "info2"
    }, [_vm._v(" " + _vm._s(item.likeReward.postCount) + " ")])])]), _c("div", {
      staticClass: "mod2 flex-col"
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 0 ? _c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    })], 1)])])]);
  }), 1) : _vm._e()], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };